import { RadioGroup, RadioGroupItem } from '../../../components/ui/radio-group.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { ExplorerTopLevelEntity } from '../../../server/utils/explorer-utils.ts';
import { allExplorerTabs } from '../../../server/utils/explorer-utils.ts';

type Props = {
    className?: string;
    tabsToShow?: ExplorerTopLevelEntity[];
    selectedTab: ExplorerTopLevelEntity;
    onTabChange: (tab: ExplorerTopLevelEntity) => void;
};

export function ExplorerTopLevelEntityTabs({
    selectedTab,
    onTabChange,
    tabsToShow = allExplorerTabs,
}: Props) {
    const { t } = useLocale();

    const handleValueChange = (value: string) => {
        onTabChange(value as ExplorerTopLevelEntity);
    };

    return (
        <RadioGroup
            value={selectedTab}
            onValueChange={handleValueChange}
            className="scrollbar-none flex shrink-0 overflow-x-auto"
        >
            {tabsToShow.map((tab) => (
                <RadioGroupItem value={tab} id="option-one" key={tab}>
                    {t(`header_tab__${tab}`, { ns: 'explorer' })}
                </RadioGroupItem>
            ))}
        </RadioGroup>
    );
}
